// Eigenbau: Lokale Anbieterzeichen ohne externe Bild- oder Laufzeitabhängigkeit

import { cx } from "@/lib/utils";

export function KiAnbieterLogo({
  anbieter,
  className,
}: {
  anbieter: "deepseek" | "openai" | "xai" | "anthropic";
  className?: string;
}) {
  if (anbieter === "deepseek") {
    return (
      <span
        className={cx(
          "flex size-10 items-center justify-center rounded-lg bg-[#4d6bfe] text-white",
          className,
        )}
        aria-label="DeepSeek"
        role="img"
      >
        <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
          <path
            fill="currentColor"
            d="M6.1 17.2c2.4 0 3.7-1 4.9-2.3.8-.9 1.7-1.8 3.2-2.2 2.3-.7 4.9.1 6.4 2l3.1-1.1c.8-.3 1.4.6.9 1.2l-2.4 2.8c.1 4.3-3.4 7.7-8.2 7.7-4.7 0-8.6-2.6-9.8-6.7-.2-.7.5-1.4 1.2-1.2.2-.1.4-.2.7-.2Z"
          />
          <circle cx="17.9" cy="15.9" r="1.1" fill="#4d6bfe" />
          <path
            d="M5.8 17.3c-1.5-1-2.4-2.4-2.6-4.3 2.1.1 3.9.8 5.2 2.1"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      </span>
    );
  }

  if (anbieter === "anthropic") {
    return (
      <span
        className={cx(
          "flex size-10 items-center justify-center rounded-lg bg-[#d97757] text-white",
          className,
        )}
        aria-label="Claude von Anthropic"
        role="img"
      >
        <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
          <path
            fill="currentColor"
            d="M19.7 5.2 8.4 26.8h3.6l2.3-4.4h7.8l2.3 4.4h3.6L16.7 5.2h-3Zm.3 13.4h-5.6L17.2 12l2.8 6.6Z"
          />
        </svg>
      </span>
    );
  }

  if (anbieter === "openai") {
    return (
      <span
        className={cx(
          "flex size-10 items-center justify-center rounded-lg bg-gray-950 text-white dark:bg-white dark:text-gray-950",
          className,
        )}
        aria-label="OpenAI"
        role="img"
      >
        <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
          <g fill="none" stroke="currentColor" strokeWidth="2.1">
            <rect x="11.2" y="3.9" width="9.6" height="16" rx="4.8" />
            <rect
              x="11.2"
              y="3.9"
              width="9.6"
              height="16"
              rx="4.8"
              transform="rotate(60 16 16)"
            />
            <rect
              x="11.2"
              y="3.9"
              width="9.6"
              height="16"
              rx="4.8"
              transform="rotate(120 16 16)"
            />
          </g>
        </svg>
      </span>
    );
  }

  return (
    <span
      className={cx(
        "flex size-10 items-center justify-center rounded-lg bg-black text-white",
        className,
      )}
      aria-label="Grok von xAI"
      role="img"
    >
      <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
        <path
          d="M7 8.5 15.8 17 8 24.5M14.4 8h10.1L17 15.4M24 14.6v9.9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
